<template>
  <el-dialog
      class="custom-modal-uniq-123"
      title=""
      :visible.sync="dialogVisible"
      :width="width"
      top="90px"
      :before-close="handleClose">
    <div class="content">
      <div class="custom_header">
        <div class="title_box">
          <div class="title_icon"></div>
          <div class="title_text">{{title}}</div>
        </div>
        <div class="close_box" @click="handleClose(()=>dialogVisible = false)">
          <img src="@/assets/icons/icon-close.png" alt="">
        </div>
      </div>
      <div :class="{'custom_main': true, 'vertical_center': verticalCenter}" :style="{'height': height}">
        <slot />
      </div>
      <div v-if="showFooter" class="custom_footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '50%'
    },
    title: {
      type: String,
      default: '提示'
    },
    height: {
      type: String,
      default: 'auto'
    },
    directlyClose: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    verticalCenter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  methods: {
    handleClose(done=()=>{this.dialogVisible = false}) {
      if(this.directlyClose) return done();
      this.$confirm('确认关闭？')
          .then(() => {
            done();
          })
          .catch(() => {});
    },
    handleOpen() {
      this.dialogVisible = true;
      console.log("打开")
    },
    // 直接关闭弹框 仅在确定操作时调用
    handleDirectlyClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss">
// 此处未设置scoped 谨防其他组件中使用custom-modal-uniq-123类名造成影响
.custom-modal-uniq-123 {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    //display: none;
    padding: 0!important;
  }
  .el-dialog__footer {
    display: none;
  }

  .content {
    width: 100%;

    .custom_header {
      width: 100%;
      height: 48px;
      background-color: rgb(2, 99, 183);
      padding: 12px 24px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;

      .title_box {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .title_icon {
          width: 6px;
          height: 6px;
          border: 2px solid rgba(255, 255, 255, 1);
          box-sizing: border-box;
          border-radius: 50%;
          margin-right: 8px;
        }

        .title_text {
          color: rgba(255, 255, 255, 1);
          font-family: "Alibaba PuHuiTi 3.0";
          font-weight: 500;
          font-size: 17px;
          line-height: 24px;
        }
      }

      .close_box {
        width: 24px;
        height: 24px;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .custom_main {
      padding: 40px 40px 20px 40px;
      overflow-y: auto;
      box-sizing: border-box;
    }

    .vertical_center {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .custom_footer {
      width: 100%;
      height: 56px;
      background-color: rgb(241, 244, 248);
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 80px;
    }
  }
}
</style>